module.exports = __webpack_public_path__ + "static/media/symbols.58f4e69b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/symbols.svg
// module id = 551
// module chunks = 0